/* 🤖 this file was generated by svg-to-ts */
export const matIconAlignHorizontalRight: {
  name: 'align-horizontal-right';
  data: string;
} = {
  name: 'align-horizontal-right',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 2h2v20h-2V2zM2 10h16V7H2v3zm6 7h10v-3H8v3z"/></svg>`
};
